import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";
import React from "react";
import birthdayParty from "../../../assests/img/birthdayParty.jpg";

function BirthdayOfferContent() {
  return (
    <Box display="flex" flexDirection="column">
      <Box sx={{ textAlign: "center", mt: 1 }}>
        <Typography variant="mobilePageTitle">Proslava Rođendana</Typography>
      </Box>
      <Box
        sx={{ opacity: "0.8", padding: "8px" }}
        component="img"
        height="200px"
        src={birthdayParty}
        alt="birthday-cake"
      />
      <Box padding="1rem">
        <Typography variant="birthdayContent">
          Naša igraonica je savršeno mesto za organizaciju dečijih rođendana.
          <br />
          <br />
          Sa širokim izborom igara, hrane i pića, deca će se zabaviti i uživati
          u svojim rođendanskim proslavama.
          <br />
          <br />
        </Typography>
      </Box>
    </Box>
  );
}

export default BirthdayOfferContent;
